import styled from 'styled-components';
import React from 'react';
import { Box } from 'components/Grid';
import { TransitionGroup, Transition as ReactTransition } from 'react-transition-group';

const MainStyled = styled(Box).attrs({
	as: 'main'
})`
	overflow: hidden;
	min-height: 100vh;
`;

MainStyled.defaultProps = {
	mt: 'headerHeight'
};

const timeout = 600;

const getTransitionStyles = {
	entering: {
		opacity: 0
	},
	entered: {
		transition: `opacity ${timeout}ms ease-in-out`,
		opacity: 1
	},
	exiting: {
		transition: `opacity 300ms ease-in-out`,
		opacity: 0
	}
};

const Transition = props => (
	<TransitionGroup>
		<ReactTransition
			key={props.location.pathname}
			timeout={{
				enter: timeout,
				exit: timeout
			}}
		>
			{status => (
				<div
					style={{
						display: 'block',
						...getTransitionStyles[status]
					}}
				>
					<MainStyled>{props.children}</MainStyled>
				</div>
			)}
		</ReactTransition>
	</TransitionGroup>
);

export default Transition;
